const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const closeFallback = 240;
const initializedDisclosures = new WeakSet();
const disclosureControllers = new Set();

const clearScheduledMotion = (controller) => {
  window.cancelAnimationFrame(controller.frame);
  window.clearTimeout(controller.closeTimer);
  controller.frame = 0;
  controller.closeTimer = 0;
};

const finishClose = (controller) => {
  if (controller.details.dataset.equipmentHubDisclosureState !== 'closing') {
    return;
  }

  clearScheduledMotion(controller);
  controller.details.open = false;
  controller.details.dataset.equipmentHubDisclosureState = 'closed';
  controller.content.inert = true;
};

const closeDisclosure = (controller, { immediate = false } = {}) => {
  clearScheduledMotion(controller);
  controller.content.inert = true;

  if (!controller.details.open || immediate || reducedMotion.matches) {
    controller.details.open = false;
    controller.details.dataset.equipmentHubDisclosureState = 'closed';
    return;
  }

  controller.details.dataset.equipmentHubDisclosureState = 'closing';
  controller.closeTimer = window.setTimeout(() => finishClose(controller), closeFallback);
};

const openDisclosure = (controller) => {
  clearScheduledMotion(controller);

  disclosureControllers.forEach((candidate) => {
    if (
      candidate !== controller &&
      controller.group &&
      candidate.group === controller.group
    ) {
      closeDisclosure(candidate);
    }
  });

  controller.details.open = true;
  controller.content.inert = false;

  if (
    reducedMotion.matches ||
    controller.details.dataset.equipmentHubDisclosureState === 'closing'
  ) {
    controller.details.dataset.equipmentHubDisclosureState = 'open';
    return;
  }

  controller.details.dataset.equipmentHubDisclosureState = 'opening';
  controller.content.getBoundingClientRect();
  controller.frame = window.requestAnimationFrame(() => {
    controller.frame = 0;

    if (controller.details.dataset.equipmentHubDisclosureState === 'opening') {
      controller.details.dataset.equipmentHubDisclosureState = 'open';
    }
  });
};

const initializeDisclosure = (details) => {
  if (!(details instanceof HTMLDetailsElement) || initializedDisclosures.has(details)) {
    return;
  }

  const summary = details.querySelector(':scope > summary');
  const content = details.querySelector(':scope > [data-equipment-hub-disclosure-content]');

  if (!(summary instanceof HTMLElement) || !(content instanceof HTMLElement)) {
    return;
  }

  const controller = {
    details,
    summary,
    content,
    group: details.getAttribute('name') || '',
    frame: 0,
    closeTimer: 0,
  };

  if (controller.group) {
    details.removeAttribute('name');
  }

  details.dataset.equipmentHubDisclosureState = details.open ? 'open' : 'closed';
  content.inert = !details.open;
  initializedDisclosures.add(details);
  disclosureControllers.add(controller);

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    const state = details.dataset.equipmentHubDisclosureState;

    if (state === 'open' || state === 'opening') {
      closeDisclosure(controller, { immediate: state === 'opening' });
    } else {
      openDisclosure(controller);
    }
  });

  content.addEventListener('transitionend', (event) => {
    if (event.target === content && event.propertyName === 'grid-template-rows') {
      finishClose(controller);
    }
  });
};

const initializeEquipmentHubDisclosures = (root = document) => {
  root
    .querySelectorAll('[data-equipment-hub-disclosure]')
    .forEach((details) => initializeDisclosure(details));
};

initializeEquipmentHubDisclosures();

document.addEventListener('shopify:section:load', (event) => {
  initializeEquipmentHubDisclosures(event.target);
});
